import React, { FC } from 'react';
import i18next, { InterpolationOptions } from 'i18next';
import hoistNonReactStatics from 'hoist-non-react-statics';
import noop from 'lodash/noop';

import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';

import compose from '../../../utils/components/#compose';
import configureI18next from './configureI18next';
import implementTranslation from '../implementTranslation';

export interface ConfigTranslationProps {}

export interface ConfigTranslationOptions {
  saveCookie?: boolean;
  debug?: boolean;
  detection?: Record<string, unknown>;
  interpolation?: InterpolationOptions;
}

export interface ConfigTranslationMock {}

/**
 * @component
 * @visibleName configTranslation
 */
export default function configTranslation(options: ConfigTranslationOptions) {
  configureI18next(options).catch(noop);

  return (WrappedComponent: FC<ConfigTranslationProps>) => {
    const ComposedWrappedComponent = compose(
      implementTranslation({
        t: (key, opts) => i18next.t(key, opts),
        getLanguage: () => i18next.language,
        addTranslation: (language, namespace, messages) => i18next.addResourceBundle(language, namespace, messages),
        changeLanguage: (newLanguage) => i18next.changeLanguage(newLanguage),
        onLanguageChange: (callback) => i18next.on('languageChanged', callback),
        offLanguageChange: (callback) => i18next.off('languageChanged', callback),
      }),
    )(WrappedComponent);

    const ConfigTranslation = (props: ConfigTranslationProps) => (
      <ComposedWrappedComponent {...props} />
    );

    ConfigTranslation.displayName = getWrappedDisplayName('ConfigTranslation', WrappedComponent);

    return hoistNonReactStatics(ConfigTranslation, WrappedComponent);
  };
}
